class CartUpsells extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("scroll", this.handleScroll.bind(this));
    this.scrollForMoreButton = this.querySelector(
      "[data-action='scroll-for-more']",
    );
    this.scrollForMoreButton.addEventListener(
      "click",
      this.handleScrollForMore.bind(this),
    );
  }

  connectedCallback() {
    if (this.scrollHeight <= 283) {
      this.scrollForMoreButton.removeAttribute("data-visible");
      document.querySelector("cart-upsells + hr").remove();
    }
  }

  handleScroll() {
    this.scrollTop >= 1
      ? this.classList.add("border-t")
      : this.classList.remove("border-t");
    this.scrollForMoreButton.removeAttribute("data-visible");
  }

  handleScrollForMore() {
    this.scrollBy({
      top: 200,
      left: 0,
      behavior: "smooth",
    });
    this.scrollForMoreButton.blur();
    this.scrollForMoreButton.removeAttribute("data-visible");
  }
}

customElements.define("cart-upsells", CartUpsells);
